import { useState } from 'react'
import { useSnackbar } from '../../context/SnackBarContext'
import CrmInvoiceUI from '../../features/Crm/CrmInvoiceUI/CrmInvoiceUI'
import { CrmInvoiceForm } from '../../features/Crm/CrmInvoiceUI/CrmInvoiceForm'
import { CrmInvoiceBill } from '../../features/Crm/CrmInvoiceUI/CrmInvoiceBill'
import { apiUrl} from '../../utils/utils';
import { useNavigate } from 'react-router-dom';
import fetcher from '../../helper/fetcher';

const CrmInvoice = () => {
    const navigate = useNavigate()
    const { showSuccess, showError } = useSnackbar();
    const [state, setState] = useState({
        isModalOpen: false,
        selectedContact: null,
        isDrawerOpen: false,
        isContactDrawerOpen: false,
        isProductDrawerOpen: false,
        availableUser: [],
        isLoading: false,
        searchQuery: '',
        memo: '',
    })
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        invoiceDate: "",
        paymentStatus: "",
        paymentDate: "",
        salesPersonContactNo: "",
        shippingDate: "",
        salesPerson: "",
        paymentMode: "",
        withGST: true,
        customerName: "",
        gst: "",
        billAddress: "",
        shipingAddress: "",
        customerPhone: "",
        state: "",
    });
    const [tableData, setTableData] = useState([{
        id: 1,
        productId: "",
        product: "",
        productCode: "",
        description: "",
        quantity: '',
        availableQty: '',
        UOM: "",
        price: '',
        discount: '',
        tax: "",
        amount: '',
    }]);

    const [billingData, setBillingData] = useState({
        subTotal: "0.00",
        totalDiscount: '0.00',
        beforeTax: '0.00',
        tax: '0.00',
        tcs: '0.00',
        roundOff: '0',
        total: '0.00',

    })

    const updateState = (data) => {
        setState((prevState) => {
            const newState = { ...prevState, ...data }
            return newState
        })
    }

    const handleSaveCrmInvoice = () => {
        const payload = {
            invoiceDate: formData.invoiceDate,
            paymentStatus: formData.paymentStatus,
            shippingDate: formData.shippingDate,
            paymentDate: formData.paymentDate,
            salesPersonContactNo: formData.salesPersonContactNo,
            trackingId: formData.trackingId,
            paymentMode: formData.paymentMode,
            salesPerson: formData.salesPerson,

            // Fix field names
            gst: formData.gstNumber,
            billAddress: formData.billAddress,
            shipingAddress: formData.shipingAddress,
            customerName: formData.customerName,
            customerPhone: formData.phoneNumber,
            withGst: formData.withGST,
            state: formData.state,
            // Billing
            beforeTax:billingData.beforeTax,
            total: billingData.total,
            subTotal: billingData.subTotal,
            totalDiscount: billingData.totalDiscount,
            tax: billingData.tax,
            memo: state.memo,
            

            // Products
            product: tableData.map(item => ({
                productId: item.productId,
                igst: item.igst || null,
                cgst: item.cgst || null,
                sgst: item.sgst || null,
                price: item.price || null,
                quantity: item.quantity || null,
                discount: item.discount || null,
                amount: item.amount || null,
                unit: item.unit || null,
            }))
        };

        if (!billingData.subTotal) {
            return showError("Subtotal is Required");
        }

        updateState({ isLoading: true });
        fetcher.post(`${apiUrl}crm/invoice/create_invoice`, payload)
            .then((res) => {
                showSuccess("Invoice Created successfully");
                setTimeout(() => {
                    navigate("/crm/manage-invoice");
                }, 1000);
            })
            .catch((error) => {
                showError(error.response?.data?.message);
                console.log("erorrrrr", error);
            })
            .finally(() => {
                updateState({ isLoading: false });
                setTimeout(() => {
                    setModalOpen(false);
                }, 500);
            });
    };


    return (
        <div className='bg-white rounded-lg pb-12'>
            <CrmInvoiceForm
                state={state}
                updateFunc={updateState}
                formData={formData}
                handleSaveCrmInvoice={handleSaveCrmInvoice}
                setFormData={setFormData}
                billingData={billingData}
                setModalOpen={setModalOpen}
                tableData={tableData}
                modalOpen={modalOpen}
                setTableData={setTableData}
                setBillingData={setBillingData}
            />
            <CrmInvoiceUI
                setBillingData={setBillingData}
                state={state}
                setTableData={setTableData}
                updateFunc={updateState}
                tableData={tableData}
                formData={formData}
            />
            <CrmInvoiceBill
                state={state}
                updateFunc={updateState}
                billingData={billingData}
                formData={formData}
                tableData={tableData}

            />
        </div>
    )
}

export default CrmInvoice
